export const API_URL = {
  baseUrl: 'https://api.viplaty.ru',
};
